import {
  AssessmentStateV2,
  PILLARS_V2,
  PillarV2,
  SINS_V2,
  SinV2,
} from "../../types/engagementAssessmentV2Types";
import {
  compassBordeaux,
  compassGreyBackground,
  compassLightGreen,
  compassOrange,
  compassPaleGreen,
  compassYellow,
} from "../../styles";

export const PILLAR_DISPLAY_ORDER: readonly PillarV2[] = PILLARS_V2;

export const SIN_DISPLAY_ORDER: readonly SinV2[] = SINS_V2;

export const stateScore: Readonly<Record<AssessmentStateV2, number | null>> = {
  STRONG: 1.0,
  ADEQUATE: 0.75,
  MIXED: 0.5,
  WEAK: 0.25,
  NOT_RATABLE: null,
};

export const PILLAR_HEATMAP_BANDS = [
  "STRONG",
  "ADEQUATE",
  "MIXED",
  "WEAK",
  "NOT_RATABLE",
] as const;
export type PillarHeatmapBand = (typeof PILLAR_HEATMAP_BANDS)[number];

export const PILLAR_HEATMAP_THRESHOLDS: Readonly<
  Record<PillarHeatmapBand, number>
> = {
  STRONG: 0.875,
  ADEQUATE: 0.625,
  MIXED: 0.375,
  WEAK: 0.125,
  NOT_RATABLE: 0,
};

export const PILLAR_HEATMAP_COLORS: Readonly<
  Record<PillarHeatmapBand, string>
> = {
  STRONG: compassLightGreen,
  ADEQUATE: compassPaleGreen,
  MIXED: compassYellow,
  WEAK: compassOrange,
  NOT_RATABLE: compassGreyBackground,
};

export const PILLAR_HEATMAP_COLOR_SCALE: readonly string[] = [
  PILLAR_HEATMAP_COLORS.NOT_RATABLE,
  PILLAR_HEATMAP_COLORS.WEAK,
  PILLAR_HEATMAP_COLORS.MIXED,
  PILLAR_HEATMAP_COLORS.ADEQUATE,
  PILLAR_HEATMAP_COLORS.STRONG,
];

export const getPillarHeatmapBand = (value: number): PillarHeatmapBand => {
  if (value >= PILLAR_HEATMAP_THRESHOLDS.STRONG) return "STRONG";
  if (value >= PILLAR_HEATMAP_THRESHOLDS.ADEQUATE) return "ADEQUATE";
  if (value >= PILLAR_HEATMAP_THRESHOLDS.MIXED) return "MIXED";
  if (value >= PILLAR_HEATMAP_THRESHOLDS.WEAK) return "WEAK";
  return "NOT_RATABLE";
};

export const SIN_HEATMAP_BANDS = [
  "clean",
  "warning",
  "alert",
  "severe",
] as const;
export type SinHeatmapBand = (typeof SIN_HEATMAP_BANDS)[number];

export const SIN_HEATMAP_THRESHOLDS: Readonly<
  Record<SinHeatmapBand, number>
> = {
  clean: 0,
  warning: 0,
  alert: 0.25,
  severe: 0.5,
};

export const SIN_HEATMAP_COLORS: Readonly<Record<SinHeatmapBand, string>> = {
  clean: compassLightGreen,
  warning: compassYellow,
  alert: compassOrange,
  severe: compassBordeaux,
};

export const SIN_HEATMAP_COLOR_SCALE: readonly string[] = [
  SIN_HEATMAP_COLORS.clean,
  SIN_HEATMAP_COLORS.warning,
  SIN_HEATMAP_COLORS.alert,
  SIN_HEATMAP_COLORS.severe,
];

export const getSinHeatmapBand = (value: number): SinHeatmapBand => {
  if (value <= 0) return "clean";
  if (value <= 0.25) return "warning";
  if (value <= 0.5) return "alert";
  return "severe";
};

export const DEFAULT_DATE_RANGE_DAYS = 90;
